import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Button, Typography } from '@mui/material';
import ConfirmContainer from './confirm';
import { AuthEventKeys, AuthEvents } from '../events';
import { EventBus } from '@/shared/utils';
import { Auth, getDictErrorMessage, getModuleDictionary } from '@/shared/i18n';

type ActivateResultProps = {
  eventBus: EventBus<AuthEvents>;
  dict: Auth;
};

function ActivateResult({ eventBus, dict }: ActivateResultProps) {
  const [activationError, setActivationError] = useState<string | null>(null);
  const errorHandled = useRef(false);
  // Gestione degli errori tramite eventBus
  useEffect(() => {
    const handleError = (error: Error) => {
      if (!errorHandled.current) {
        const errorMessage = getDictErrorMessage(dict.auth_errors, error.message);
        setActivationError(errorMessage);
        errorHandled.current = true;
      }
    };

    eventBus.on(AuthEventKeys.activate.error, handleError);

    return () => {
      eventBus.off(AuthEventKeys.activate.error, handleError);
    };
  }, [eventBus, dict]);

  return (
    <section className="flex z-10 flex-col self-center max-w-[600px] px-6 py-8 md:px-16 md:py-12 rounded-xl bg-paper">
      <ConfirmContainer
        imgSrc={
          activationError ? '/assets/images/error-generic.svg' : '/assets/images/success-green.svg'
        }
        title={
          activationError
            ? dict.activate_result?.error_title || 'Si è verificato un errore'
            : dict.activate_result?.success_title || 'Account creato'
        }
        mailfield={false}
        description={
          activationError
            ? activationError
            : dict.activate_result?.success_description ||
              'Il tuo account è stato creato. Adesso puoi accedere al catalogo.'
        }
        footer={
          <div className="flex flex-col w-full mt-8">
            <Button
              size="large"
              variant="contained"
              color="primary"
              className="w-full max-md:max-w-full"
              onClick={() => eventBus.emit(AuthEventKeys.login.go, undefined)}
            >
              <Typography variant="button-l">
                {dict.common?.back_to_login || 'Torna al login'}
              </Typography>
            </Button>
          </div>
        }
      />
    </section>
  );
}

export default ActivateResult;
